import getUndoSendTimeInterval from '../selectors/getUndoSendTimeInterval';
import { getUserConfiguration } from 'owa-session-store';

export default function isUndoSendOptionDirty(): boolean {
    let userOptions = getUserConfiguration().UserOptions;
    return getUndoSendTimeInterval() !== userOptions.MailSendUndoInterval;
}
